import { CancellationToken } from '@cian/http-api/shared';

import { IApplicationContext } from '../../../../../../../types/applicationContext';
import {
  fetchGetClusterPopupForMap,
  IGetClusterPopupForMapResponse200,
  IGetClusterPopupForMapResponse400,
} from '../../../../../../../repositories/search-engine/v1/get-cluster-popup-for-map';

import { IFetchGetClusterPopupParameters } from './types';
import { assertUnknownError } from './assert';

export async function fetchGetClusterPopup(context: IApplicationContext, parameters: IFetchGetClusterPopupParameters) {
  const {
    httpApi,
    cancellationTokenManager,
    custom: { subdomain },
  } = context;

  let cancellationToken: CancellationToken | undefined;
  if (cancellationTokenManager) {
    cancellationToken = cancellationTokenManager.getTokenAndCancelPrevious('fetchGetClusterPopup');
  }

  const response = await fetchGetClusterPopupForMap<
    IGetClusterPopupForMapResponse200,
    IGetClusterPopupForMapResponse400
  >({
    httpApi,
    parameters: { ...parameters, subdomain },
    config: {
      cancellationToken,
    },
  });

  assertUnknownError(response);

  return response.response;
}
